/** What a receipt says about a file the engaged Auditor may not open (D-06, option A).
 *
 * The server sends `withheld` on the document node when the file also covers sites outside the
 * engagement: the chain still ends at a document, with its SHA-256, and no file name (a name can
 * identify the other company). One sentence, said the same way in every receipt, and no link: the
 * file's own page answers this reader as an id that does not exist. The sentence never says whose
 * other rows the file holds.
 */

export const WITHHELD_DOCUMENT = "Withheld: this file also covers sites outside your engagement.";

/** The part of the document node the chain needs to decide how to draw it. */
export interface DocumentNode {
  original_filename: string | null;
  withheld?: boolean;
  sha256?: string | null;
}

export function isWithheld(document: DocumentNode | null | undefined): boolean {
  return document?.withheld === true;
}

/** The name a figure's source is shown under: the file's, or the withheld sentence. */
export function documentLabel(document: DocumentNode): string {
  return isWithheld(document) ? WITHHELD_DOCUMENT : (document.original_filename ?? "Untitled document");
}
